<template>
  <div
    v-if="loader === false"
    class="alert-body"
  >
    <b-list-group
      v-if="moduleObject.module_id === 25"
      flush
      class="awaitlist operator-list"
    >
      <!-- <b-list-group-item
        v-if="moduleObject.module_settings.is_timed"
        class="main-items"
      >
        {{ $t('DEBTIA_TIMED') }} : {{ $t('DEBTIA_YES') }}
      </b-list-group-item> -->
      <b-list-group-item
        v-if="moduleObject.module_settings.is_timed && moduleObject.module_settings.days && moduleObject.module_settings.days !== null && moduleObject.module_settings.days !== ''"
        class="main-items"
      >
        {{ $t('DEBTIA_DAYS') }} : {{ moduleObject.module_settings.days }}
      </b-list-group-item>
      <!-- <b-list-group-item
        v-if="!moduleObject.module_settings.is_timed"
        class="main-items"
      >
        {{ $t('DEBTIA_TIMED') }}: {{ $t('DEBTIA_NO') }}
      </b-list-group-item> -->
      <template>
        <b-list-group-item
          v-for="(row, index) in moduleObject.module_settings.rules"
          :key="index"
          class="main-items"
        >
          {{ $t('DEBTIA_FILE_CATEGORIES') }}: {{ row.file_category }}
          | {{ $t('DEBTIA_OPERATOR') }}: {{ row.operator }}
          <!-- | {{ $t('DEBTIA_CUSTOM_FIELD') }}: {{ row.threshold }} -->
          <!-- <span v-if="row.value_type === 'literal'">
            | {{ $t('DEBTIA_NUMBER_OF_DAYS') }}: {{ row.threshold }}
          </span>
          <span v-if="row.value_type === 'custom_variable'">
            | {{ $t('DEBTIA_CUSTOM_VARIABLE') }}: {{ row.threshold }} ({{ $t('DEBTIA_CUSTOM_FIELD') }})
          </span> -->
          <span>
            | {{ $t('DEBTIA_NUMBER_OF_UPLOADS') }}: {{ row.threshold }}<span v-if="row.value_type === 'custom_variable'"> ({{ $t('DEBTIA_CUSTOM_FIELD') }})</span>
          </span>
        </b-list-group-item>
      </template>
      <!-- <b-list-group-item
        class="main-items"
      >
        <b-form-group
          class="awaitModuleFields mb-0"
          label-cols-md="4"
        >
          <b-form-checkbox
            :id="`checkbox-timed-${moduleObject.id}`"
            v-model="moduleObject.module_settings.is_timed"
            class="custom-control-primary"
          >
            {{ $t('DEBTIA_TIMED') }}
          </b-form-checkbox>
        </b-form-group>
      </b-list-group-item>

      <b-list-group-item
        v-if="moduleObject.module_settings.is_timed"
        class="main-items"
      >
        <b-form-group
          :label="$t('DEBTIA_DAYS')"
          :label-for="`days-input-${moduleObject.id}`"
          class="awaitModuleFields mb-0"
          label-cols-md="4"
        >
          <b-form-input
            :id="`days-input-${moduleObject.id}`"
            v-model="moduleObject.module_settings.days"
            type="number"
            min="0"
          />
        </b-form-group>
      </b-list-group-item>
      <b-list-group-item
        v-for="(row, index) in moduleObject.module_settings.rules"
        :key="index"
        class="main-items"
      >
        <b-form-group
          :label="$t('DEBTIA_FILE_CATEGORIES')"
          :label-for="`content-file-category-${moduleObject.id}-${index}`"
          class="awaitModuleFields mb-1"
          label-cols-md="4"
        >
          <v-select
            v-model="row.file_category"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="sharedState.fileCategories.slice(1)"
            :reduce="val => val.value"
            :clearable="false"
            :input-id="`content-file-category-${moduleObject.id}-${index}`"
          />
        </b-form-group>

        <b-form-group
          :label="$t('DEBTIA_OPERATOR')"
          :label-for="`content-operator-${moduleObject.id}-${index}`"
          class="awaitModuleFields mb-1"
          label-cols-md="4"
        >
          <v-select
            v-model="row.operator"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="contentConditionOperatorOptions"
            :reduce="val => val.value"
            :clearable="false"
            :input-id="`content-operator-${moduleObject.id}-${index}`"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Custom Field')"
          :label-for="`content-custom-field-${moduleObject.id}-${index}`"
          class="awaitModuleFields mb-1"
          label-cols-md="4"
        >
          <v-select
            v-model="row.threshold"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="customFieldsOptions"
            :reduce="val => val.value"
            :clearable="false"
            :input-id="`content-custom-field-${moduleObject.id}-${index}`"
          />
        </b-form-group>

        <b-form-group
          v-if="row.custom_field === 'literal'"
          label="Add Custom Number"
          :label-for="`content-literal-${moduleObject.id}-${index}`"
          class="awaitModuleFields mb-1"
          label-cols-md="4"
        >
          <b-form-input
            :id="`content-literal-${moduleObject.id}-${index}`"
            v-model="row.literal_value"
            type="number"
            min="0"
            placeholder="Number of days"
          />
        </b-form-group>

      </b-list-group-item> -->

    </b-list-group>
    <b-list-group
      v-if="moduleObject.module_id !== 17 && moduleObject.module_id !== 25"
      flush
      class="awaitlist operator-list"
    >
      <b-list-group-item
        :id="'condition-statement-22'"
        class="main-items"
      >
        <b-form-group
          :label="$t('DEBTIA_CONDITION')"
          class="awaitModuleFields"
          label-for="awaitType"
          label-cols-md="4"
        >
          <v-select
            v-model="moduleObject.module_settings.condition_id"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="conditionOptions"
            :reduce="val => val.value"
            :clearable="false"
            input-id="awaitType"
            @input="changeVariable($event)"
          />
        </b-form-group>
      </b-list-group-item>
      <b-list-group-item
        v-if="moduleObject.module_id === 14"
        :id="'condition-statement-22'"
        class="main-items"
      >
        <b-form-group
          :label="$t('DEBTIA_DAYS')"
          class="awaitModuleFields"
          label-for="awaitType"
          label-cols-md="4"
        >
          <b-form-input
            v-model="moduleObject.module_settings.no_of_days"
            placeholder="Days"
            type="number"
          />
        </b-form-group>
      </b-list-group-item>
      <b-list-group-item
        v-if="moduleObject.module_id === 14"
        class="main-items"
      >
        <b-form-group
          :label="$t('DEBTIA_AWAIT_SKIP_INTEREST')"
          class="awaitModuleFields"
          label-for="checkbox-await"
          label-cols-md="4"
        >
          <b-form-checkbox
            id="checkbox-await"
            v-model="moduleObject.module_settings.skip_interest_calculation"
            class="custom-control-primary"
          />
        </b-form-group>
      </b-list-group-item>
      <b-list-group-item
        v-if="moduleObject.module_id === 14"
        class="main-items"
      >
        <b-form-group
          :label="$t('DEBTIA_AWAIT_SKIP_MONDAY')"
          class="awaitModuleFields"
          label-for="checkbox-skip-monday"
          label-cols-md="4"
        >
          <b-form-checkbox
            id="checkbox-skip-monday"
            v-model="moduleObject.module_settings.skip_monday"
            class="custom-control-primary"
          />
        </b-form-group>
      </b-list-group-item>
      <b-list-group-item
        :id="'operator-statement-22'"
        class="main-items"
      >
        <b-form-group
          v-if="CustomVariableOptions.length > 0 && CustomVarID > 0"
          :label="$t('DEBTIA_OPTIONS')"
          label-for="custom-var-options"
          class="awaitModuleFields mb-1"
          label-cols-md="4"
        >
          <v-select
            v-model="CustomVarOption"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="CustomVariableOptions"
            :reduce="val => val.value"
            :clearable="false"
            input-id="file-category"
            @input="assignOption($event)"
          />
        </b-form-group>

        <b-form-group
          v-if="varType !== false && varType !== 'select'"
          :label="$t('DEBTIA_CUTOM_VARIABLE_VALUE')"
          label-for="custom-variable-value"
          class="awaitModuleFields mb-1"
          label-cols-md="4"
        >
          <vue-timepicker
            v-if="varType === 'time'"
            v-model="moduleObject.module_settings.customVariableValue"
            input-width="100%"
            input-class="form-control"
            manual-input
            hide-clear-button
          />
          <v-select
            v-else-if="varType === 'date'"
            v-model="moduleObject.module_settings.date_type"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="dateOptions"
            :reduce="val => val.value"
            :clearable="false"
            input-id="date-options"
          />
          <b-form-textarea
            v-else-if="varType === 'multiline string'"
            id="textarea-rows"
            v-model="moduleObject.module_settings.customVariableValue"
            :placeholder="$t('DEBTIA_CUTOM_VARIABLE_VALUE')"
            rows="3"
          />
          <b-form-radio-group
            v-else-if="varType === 'boolean'"
            v-model="moduleObject.module_settings.customVariableValue"
            :options="radioOptions"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
            class="demo-inline-spacing"
          />
          <b-form-input
            v-else-if="varType === 'number'"
            v-model="moduleObject.module_settings.customVariableValue"
            type="number"
            :placeholder="$t('DEBTIA_CUTOM_VARIABLE_VALUE')"
          />
          <b-form-input
            v-else
            v-model="moduleObject.module_settings.customVariableValue"
            :placeholder="$t('DEBTIA_CUTOM_VARIABLE_VALUE')"
          />
        </b-form-group>

        <b-form-group
          v-if="varType !== false && varType === 'date'"
          :label="$t('DEBTIA_CUTOM_VARIABLE_VALUE')"
          label-for="custom-variable-value"
          class="awaitModuleFields mb-1"
          label-cols-md="4"
        >
          <b-input-group
            v-if="moduleObject.module_settings.date_type === 1"
          >
            <cleave
              v-model="daCustomVariableValue"
              class="form-control"
              :raw="false"
              :options="options.date"
              placeholder="DD-MM-YYYY"
              @input="validateDate(0, daCustomVariableValue)"
            />
            <b-input-group-append>
              <b-form-datepicker
                v-model="CustomVariableDate"
                :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                trim
                button-only
                right
                size="sm"
                @input="validateDate(1, CustomVariableDate)"
              />
            </b-input-group-append>
          </b-input-group>
          <b-form-input
            v-else
            v-model="moduleObject.module_settings.customVariableValue"
            type="number"
            placeholder="Dato Felt"
            @input="assignDatoFelt($event)"
          />
          <label
            :id="'dateerror-'+CustomVarID"
            style="color: red; display:none;"
          >*{{ $t('DEBTIA_DATE_FORMAT_ERROR') }}</label>
        </b-form-group>

        <b-form-group
          v-if="moduleObject.module_settings.condition_id === 5"
          :label="$t('DEBTIA_FILE_CATEGORIES')"
          label-for="file-category"
          class="awaitModuleFields mb-1"
          label-cols-md="4"
        >
          <v-select
            v-model="fileCategory"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="sharedState.fileCategories.slice(1)"
            :reduce="val => val.value"
            :clearable="false"
            input-id="file-category"
            @input="assignFileGroup($event)"
          />
        </b-form-group>
        <b-form-group
          v-if="moduleObject.module_settings.condition_id === 6"
          :label="$t('DEBTIA_CASE_GROUPS')"
          label-for="case-group"
          class="awaitModuleFields mb-1"
          label-cols-md="4"
        >
          <v-select
            v-model="CaseGroup"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="sharedState.CaseGroups"
            :reduce="val => val.value"
            :clearable="false"
            input-id="case-group"
            @input="assignCaseGroup($event)"
          />
        </b-form-group>

        <b-form-group
          v-if="moduleObject.module_settings.condition_id === 10"
          :label="$t('DEBTIA_TYPE')"
          label-for="custom-var-for"
          class="awaitModuleFields mb-1"
          label-cols-md="4"
        >
          <v-select
            v-model="customVarsFor"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="customVarsForArgs"
            :reduce="val => val.value"
            :clearable="false"
            input-id="custom-var-for"
            @input="getVarsFor()"
          />
        </b-form-group>

        <b-form-group
          v-if="moduleObject.module_settings.condition_id === 10"
          :label="$t('DEBTIA_CUSTOM_VARIABLES')"
          label-for="custom-var"
          class="awaitModuleFields mb-1"
          label-cols-md="4"
        >
          <v-select
            v-model="fieldFilled"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="customVars"
            :reduce="val => val.value"
            :clearable="false"
            input-id="custom-var"
            :value="''"
            @input="assignFieldVar($event)"
          >
            <template
              #selected-option-container="{ option }"
            >
              <div class="vs__selected">
                {{ $t(option.label) }}</div>
            </template>
            <template
              slot="option"
              slot-scope="option"
            >
              {{ $t(option.label) }}
            </template>
          </v-select>
        </b-form-group>

        <b-form-group
          v-if="moduleObject.module_settings.condition_id === statementConditionID"
          label="Statements"
          label-for="sub-statement-option"
          class="awaitModuleFields mb-1"
          label-cols-md="4"
        >
          <v-select
            v-model="statementsArgs"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="SubStatementOptions"
            :reduce="val => val.value"
            :clearable="false"
            input-id="sub-statement-option"
            multiple
            @input="assignStatements($event)"
          />
        </b-form-group>

        <b-form-group
          v-if="moduleObject.module_settings.condition_id === interestTypeConditionID"
          label="Type"
          label-for="interest-type"
          class="awaitModuleFields mb-1"
          label-cols-md="4"
        >
          <v-select
            v-model="interestType"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="interestConditionOptions"
            :reduce="val => val.value"
            :clearable="false"
            input-id="interest-type"
            @input="assignInterestType($event)"
          />
        </b-form-group>

        <b-form-group
          v-if="moduleObject.module_settings.condition_id === clientCollectionTypeID"
          label="Type"
          :label-for="`client-collection-type-${moduleObject.id}`"
          class="awaitModuleFields mb-1"
          label-cols-md="4"
        >
          <v-select
            v-model="clientCollectionType"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="clientCollectionTypeOptions"
            :reduce="val => val.value"
            :clearable="false"
            :input-id="`client-collection-type-${moduleObject.id}`"
            @input="assignCollectionType($event)"
          />
        </b-form-group>

        <b-form-group
          v-if="moduleObject.module_settings.condition_id === clientTypeID"
          label="Client Type"
          :label-for="`client-type-${moduleObject.id}`"
          class="awaitModuleFields mb-1"
          label-cols-md="4"
        >
          <v-select
            v-model="clientType"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="clientTypeOptions"
            :reduce="val => val.value"
            :clearable="false"
            :input-id="`client-type-${moduleObject.id}`"
            @input="assignClientType($event)"
          />
        </b-form-group>

        <b-form-group
          v-if="moduleObject.module_settings.condition_id === statementConditionID"
          label="Value"
          label-for="statement-value"
          class="awaitModuleFields mb-1"
          label-cols-md="4"
        >
          <b-form-input
            v-model="moduleObject.module_settings.condition_value"
            placeholder="Value"
            @input="assignStatementsValue($event)"
          />
        </b-form-group>

        <b-form-group
          :label="$t('DEBTIA_OPERATOR')"
          class="awaitModuleFields mb-1"
          label-for="process-operator"
          label-cols-md="4"
        >
          <v-select
            v-if="moduleObject.module_settings.condition_id === statementConditionID"
            v-model="conditionOperator"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="statementOperatorOptions"
            :reduce="val => val.value"
            :clearable="false"
            input-id="process-operator"
            @input="assignOperator($event)"
          />
          <v-select
            v-else
            v-model="conditionOperator"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="operatorOptions"
            :reduce="val => val.value"
            :clearable="false"
            input-id="process-operator"
            @input="assignOperator($event)"
          />
        </b-form-group>
      </b-list-group-item>
    </b-list-group>
    <b-list-group
      v-else-if="moduleObject.module_id === 17"
      flush
      class="awaitlist operator-list"
    >
      <b-list-group-item
        class="main-items"
      >
        Bailiff Conclusion Popup
      </b-list-group-item>
    </b-list-group>
    <b-row
      class="row-yes-no"
    >
      <b-col
        cols="12"
        md="6"
        class="column-no"
      >
        <b-alert
          variant="primary"
          show
        >
          <div>
            <b-list-group
              flush
              class="split-div"
            >
              <b-list-group-item
                class="yes-no"
              >
                {{ moduleObject.module_id !== 17 ? $t('DEBTIA_NO') : $t('DEBTIA_BAILIFF_NO') }}
              </b-list-group-item>
              <b-list-group-item
                class="noBackGround"
              >
                <inner-modules-list
                  :ref="`noModules-${moduleObject.id}`"
                  :modules-object="noObject"
                  :module-object-id="moduleObject.id"
                  :main-div-id="mainDivId"
                  :contact-options="contactOptions"
                />
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </b-col>
      <b-col
        cols="12"
        md="6"
        class="column-yes"
      >
        <b-alert
          variant="primary"
          show
        >
          <div>
            <b-list-group
              flush
              class="split-div"
            >
              <b-list-group-item
                class="yes-no"
              >
                {{ moduleObject.module_id !== 17 ? $t('DEBTIA_YES') : $t('DEBTIA_BAILIFF_YES') }}
              </b-list-group-item>
              <b-list-group-item
                class="noBackGround"
              >
                <inner-modules-list
                  :ref="`yesModules-${moduleObject.id}`"
                  :modules-object="yesObject"
                  :module-object-id="moduleObject.id"
                  :main-div-id="mainDivId"
                  :contact-options="contactOptions"
                />
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BRow, BCol, BAlert, BListGroup, BListGroupItem, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BFormDatepicker,
  BFormRadioGroup, BFormTextarea, BFormCheckbox,
} from 'bootstrap-vue'
// import axios from '@axios'
import axios from '@axios'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
import VueTimepicker from 'vue2-timepicker'
import InnerModulesList from './InnerModulesList.vue'
// import Ripple from 'vue-ripple-directive'
// import i18n from '@/libs/i18n'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  inject: ['sharedState'], // Inject the reactive shared state
  components: {
    BRow,
    BCol,
    BAlert,
    BListGroup,
    BListGroupItem,
    InnerModulesList,
    vSelect,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormDatepicker,
    Cleave,
    BFormRadioGroup,
    VueTimepicker,
    BFormTextarea,
    BFormCheckbox,
  },
  props: {
    contactOptions: {
      type: Array,
      required: true,
    },
    moduleObject: {
      type: Object,
      required: true,
    },
    allModules: {
      type: Array,
      required: true,
    },
    mainDivId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      SubStatementValue: '',
      noObject: [],
      yesObject: [],
      conditionOptions: [],
      loader: true,
      operatorOptions: [
        { label: 'True', value: 1 },
        { label: 'False', value: 2 },
      ],
      varType: false,
      CustomVarOption: 0,
      CustomVariableOptions: [],
      CustomVariableValue: '',
      daCustomVariableValue: '',
      dateOptions: [
        { label: 'Custom Date', value: 1 },
        { label: 'Dato Felt', value: 2 },
      ],
      radioOptions: [
        { item: 'true', name: 'True' },
        { item: 'false', name: 'False' },
      ],
      statementOperatorOptions: [
        { label: 'Greater Than (>)', value: 7 },
        { label: 'Greater Than, Equal to (>=)', value: 9 },
        { label: 'Less Than (<)', value: 8 },
        { label: 'Less Than, Equal to (<=)', value: 10 },
        { label: 'Equal to (=)', value: 3 },
      ],
      interestConditionOptions: [
        { label: 'First', value: 'first' },
        { label: 'Last', value: 'last' },
        { label: 'Any', value: 'any' },
      ],
      customVar: '',
      customVarsFor: 'debtor',
      customVarsForArgs: [
        {
          label: 'Debtor',
          value: 'debtor',
        },
        {
          label: 'Case',
          value: 'case',
        },
      ],
      SubStatementLabel: '',
      SubStatementOptions: [],
      options: {
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['d', 'm', 'Y'],
        },
      },
      CustomVarID: 0,
      fileCategory: 0,
      CaseGroup: 0,
      fieldFilled: 0,
      customVarsArgs: this.sharedState.customVarsArgs,
      // customFieldsOptions: this.sharedState.CustomVarsForInt,
      customVars: [],
      statementConditionID: 0,
      statementsArgs: [],
      interestTypeConditionID: 0,
      conditionOperator: '',
      CustomVariableDate: '',
      interestType: '',
      datoFeltValue: '',
      conditionType: '',
      clientCollectionTypeID: 0,
      clientCollectionType: '',
      clientCollectionTypeOptions: [
        { label: 'Own', value: 'own' },
        { label: 'Foreign', value: 'foreign' },
      ],
      clientTypeOptions: [
        { label: 'Person', value: 'person' },
        { label: 'Sole Proprietorship', value: 'sole-proprietorship' },
        { label: 'Capital Company', value: 'capital-company' },
      ],
      clientType: '',
      clientTypeID: 0,
      // contentConditionOperatorOptions: [
      //   { label: '=', value: 3 },
      //   { label: '!=', value: 4 },
      //   { label: '>', value: 7 },
      //   { label: '<', value: 8 },
      //   { label: '>=', value: 9 },
      //   { label: '<=', value: 10 },
      // ],
    }
  },
  watch: {
    'moduleObject.module_settings.condition_id': {
      handler() {
        // DEB-461 show statementOperatorOptions for date type custom vars
        const filteredOptions = this.conditionOptions.filter(e => e.value === this.moduleObject.module_settings.condition_id && e.type === 'date')
        if (filteredOptions.length) {
          if (this.operatorOptions.length === 2) {
            this.operatorOptions.push(...this.statementOperatorOptions)
          }
        } else {
          this.operatorOptions.splice(2)
        }
        this.moduleObject.module_settings.operator = ''
        this.conditionOperator = ''
        this.fileCategory = 0
        this.CaseGroup = 0
        this.fieldFilled = 0
        this.CustomVarOption = 0
        this.interestType = ''
        this.clientCollectionType = ''
        this.clientType = ''
        this.assignCollectionType(this.clientCollectionType)
        this.assignClientType(this.clientType)
      },
    },
    moduleObject: {
      handler() {
        this.refreshcomponent()
      },
    },
    allModules: {
      handler() {
        this.refreshcomponent()
      },
    },
    'moduleObject.module_settings.date_type': {
      handler() {
        this.CustomVariableDate = ''
        this.daCustomVariableValue = ''
      },
    },
  },
  created() {
    this.getConditions()
    this.refreshcomponent()
    if (this.moduleObject.module_settings.statement) {
      this.getSubStatements()
    }
  },
  methods: {
    validateDate(type, value) {
      if (type === 0) {
        this.CustomVariableDate = this.$FormformattedDate(value)
        this.moduleObject.module_settings.customVariableValue = this.CustomVariableDate
      } else {
        this.daCustomVariableValue = this.$DAformattedDate(value)
        this.moduleObject.module_settings.customVariableValue = this.daCustomVariableValue
      }
      this.moduleObject.module_settings.fields = [{ value: this.moduleObject.module_settings.customVariableValue }]
    },
    async getSubStatements() {
      this.busy = true
      const getStatementlabel = this.conditionOptions.filter(e => e.value === this.moduleObject.module_settings.condition_id)
      this.SubStatementLabel = getStatementlabel.length > 0 ? getStatementlabel[0].label : ''
      this.SubStatementOptions = []
      await axios.get('/get-sub-statements').then(response => {
        if (response.status === 200) {
          this.SubStatementOptions.push(...response.data.data)
          this.busy = false
        }
      }).catch(error => console.log(error))
    },
    getVarsFor(value = null) {
      this.moduleObject.module_settings.fields[0].value = this.customVarsFor
      this.customVars = this.customVarsArgs.filter(e => e.var_for === this.customVarsFor)
      this.fieldFilled = value !== null ? value : 0
      this.moduleObject.module_settings.CustomVarID = null
    },
    convertDate(dt) {
      const parts = dt.split('-')
      const year = Number(parts[0])
      const month = Number(parts[1])
      const day = Number(parts[2])
      const formattedDate = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''}${month}-${year}`
      return formattedDate
    },
    changeVariable(event) {
      const currentValue = typeof event === 'object' ? event.condition_id : event
      this.varType = false
      this.CustomVarOption = 0
      this.CustomVariableOptions = []
      this.CustomVariableValue = typeof event === 'object' && event.fields.length > 0 ? event.fields[0].value : event
      this.CustomVariableDate = typeof event === 'object' && event.fields.length > 0 && event.fields[0].type === 'date' ? event.fields[0].value : ''
      this.daCustomVariableValue = typeof event === 'object' && event.fields.length > 0 && event.fields[0].type === 'date' ? this.convertDate(event.fields[0].value) : ''
      this.conditionOperator = this.moduleObject.module_settings.operator
      this.conditionOptions.filter(e => {
        if (currentValue === e.value) {
          if (e.type === 'select') {
            if (e.options.length > 0) {
              this.CustomVariableOptions.push(...e.options)
            } else {
              this.CustomVariableOptions.push(...this.sharedState.AirportsData)
            }
            this.CustomVarOption = typeof event === 'object' && event.fields.length > 0 ? this.CustomVariableValue : 0
          }
          this.varType = e.type
          this.CustomVarID = e.customVarID
          this.moduleObject.module_settings.CustomVarID = e.customVarID
          this.moduleObject.module_settings.optionValue = this.CustomVarOption
          this.moduleObject.module_settings.customVariableValue = ''
          this.fileCategory = currentValue === 5 ? this.moduleObject.module_settings.fields[0]?.value ?? 0 : 0
          this.moduleObject.module_settings.fileCategory = this.fileCategory
          this.CaseGroup = currentValue === 6 ? this.moduleObject.module_settings.fields[0]?.value ?? 0 : 0
          this.moduleObject.module_settings.CaseGroup = this.CaseGroup
          this.fieldFilled = currentValue === 10 ? this.moduleObject.module_settings.fields[1]?.value ?? this.fieldFilled : this.fieldFilled

          if (currentValue === 10) {
            this.moduleObject.module_settings.fields = this.moduleObject.module_settings.fields[1] !== undefined && this.conditionType !== 'statements' ? [...this.moduleObject.module_settings.fields] : [{ value: this.customVarsFor }, { value: this.fieldFilled }]
            this.moduleObject.module_settings.customVarsFor = currentValue === 10 ? this.moduleObject.module_settings.fields[0]?.value ?? 'debtor' : 'debtor'
            this.customVarsFor = this.moduleObject.module_settings.customVarsFor
            this.getVarsFor(this.fieldFilled)
            this.moduleObject.module_settings.CustomVarID = this.fieldFilled
            this.conditionType = 'filledFields'
          }
          if (this.varType === 'date') {
            if (this.moduleObject.module_settings.date_type === 1) {
              this.CustomVariableDate = this.moduleObject.module_settings.fields[0]?.value ?? ''
              this.daCustomVariableValue = this.convertDate(this.moduleObject.module_settings.fields[0]?.value) ?? ''
              this.moduleObject.module_settings.customVariableValue = this.CustomVariableDate
            } else {
              this.moduleObject.module_settings.customVariableValue = this.moduleObject.module_settings.fields[0]?.value ?? ''
            }
            if (this.operatorOptions.length === 2) {
              this.operatorOptions.push(...this.statementOperatorOptions)
            }
          } else {
            this.operatorOptions.splice(2)
          }
          if (this.varType === 'boolean' || this.varType === 'string' || this.varType === 'number' || this.varType === 'time' || this.varType === 'multiline string') {
            this.moduleObject.module_settings.customVariableValue = this.moduleObject.module_settings.fields[0]?.value ?? ''
          }

          this.moduleObject.module_settings.statements = []
          this.moduleObject.module_settings.condition_value = 1
          if (currentValue === this.statementConditionID) {
            this.statementsArgs = []
            this.moduleObject.module_settings.fields = this.moduleObject.module_settings.fields[1] !== undefined && this.conditionType !== 'filledFields' ? [...this.moduleObject.module_settings.fields] : [{ value: [] }, { value: 0 }]
            this.moduleObject.module_settings.condition_value = this.moduleObject.module_settings?.fields[1]?.value ?? 0
            this.statementsArgs.push(...this.moduleObject.module_settings.fields[0]?.value ?? [])
            this.assignStatements(this.statementsArgs, true)
            this.conditionType = 'statements'
            this.moduleObject.module_settings.statement = true
          } else {
            this.moduleObject.module_settings.statement = false
          }
          this.interestType = currentValue === this.interestTypeConditionID ? this.moduleObject.module_settings.fields[0]?.value ?? '' : ''
          this.moduleObject.module_settings.interestType = this.interestType

          this.clientCollectionType = currentValue === this.clientCollectionTypeID ? this.moduleObject.module_settings.fields[0]?.value ?? '' : ''
          this.moduleObject.module_settings.clientCollectionType = this.clientCollectionType

          this.clientType = currentValue === this.clientTypeID ? this.moduleObject.module_settings.fields[0]?.value ?? '' : ''
          this.moduleObject.module_settings.clientTypeValue = this.clientType
        }
        return true
      })
    },
    getTheObject() {
      const yesmodules = this.$refs[`yesModules-${this.moduleObject.id}`].getNestedModules(1)
      const nomodules = this.$refs[`noModules-${this.moduleObject.id}`].getNestedModules(0)
      const result = []
      if (yesmodules.length > 0) {
        result.push(...yesmodules)
      }
      if (nomodules.length > 0) {
        result.push(...nomodules)
      }
      return result
    },
    refreshcomponent() {
      this.getNoObject()
      this.getYesObject()
    },
    getNoObject() {
      const md = this.allModules
      this.noObject = []
      md.forEach(element => {
        if (element.condition === 0 && element.depends_on === this.moduleObject.id) {
          this.noObject.push(element)
        }
      })
    },
    getYesObject() {
      const md = this.allModules
      this.yesObject = []
      md.forEach(element => {
        if (element.condition === 1 && element.depends_on === this.moduleObject.id) {
          this.yesObject.push(element)
        }
      })
    },
    getConditionStatement(id) {
      const conditionTitle = this.conditionOptions.filter(element => element.value === id)
      return this.$t(conditionTitle[0].label)
    },
    async getConditions() {
      this.loader = true
      await axios.get('/process/get-conditions').then(response => {
        if (response.status === 200) {
          this.conditionOptions.push(...response.data.data.variables)
          const conditionID = this.conditionOptions.filter(e => e.label === 'Statements')
          this.statementConditionID = conditionID.length > 0 ? conditionID[0].value : 0
          const interestTypeID = this.conditionOptions.filter(e => e.label === 'Is Interest Type Custom?')
          this.interestTypeConditionID = interestTypeID.length > 0 ? interestTypeID[0].value : 0
          const clientCollectionTypeID = this.conditionOptions.filter(e => e.label === 'Is client Collection Type?')
          this.clientCollectionTypeID = clientCollectionTypeID.length > 0 ? clientCollectionTypeID[0].value : 0

          const getClientTypeID = this.conditionOptions.filter(e => e.label === 'Check client type')
          this.clientTypeID = getClientTypeID.length > 0 ? getClientTypeID[0].value : 0
          this.loader = false
        }
      }).catch(error => console.log(error))
      if (this.moduleObject.module_id !== 17 && this.moduleObject.module_id !== 25) {
        this.changeVariable(this.moduleObject.module_settings)
      }
    },
    assignOption(value) {
      this.moduleObject.module_settings.optionValue = value !== null ? value : 0
    },
    assignFileGroup(value) {
      this.moduleObject.module_settings.fileCategory = value
      this.moduleObject.module_settings.fields = [{ value }]
    },
    assignCaseGroup(value) {
      this.moduleObject.module_settings.CaseGroup = value
      this.moduleObject.module_settings.fields = [{ value }]
    },
    assignFieldVar(value) {
      this.moduleObject.module_settings.fields[1].value = value
      this.moduleObject.module_settings.CustomVarID = value
    },
    async assignStatements(event, initialState = false) {
      if (this.SubStatementOptions.length === 0 && initialState) {
        await this.getSubStatements()
      }
      this.moduleObject.module_settings.fields = [
        { value: this.statementsArgs, options: this.SubStatementOptions }, { value: this.moduleObject.module_settings.condition_value },
      ]
      this.moduleObject.module_settings.statements = []
      const arr = []
      this.statementsArgs.map(e => this.SubStatementOptions.filter(el => {
        if (e === el.value) {
          arr.push({
            statement_id: el.value,
            statement_type: el.type,
          })
        }
        return arr
      }))
      this.moduleObject.module_settings.statements.push(...arr)
    },
    assignStatementsValue(value) {
      this.moduleObject.module_settings.fields[1].value = value
    },
    assignInterestType(value) {
      this.moduleObject.module_settings.interestType = value
      this.moduleObject.module_settings.fields = [{ value }]
    },
    assignOperator(value) {
      this.moduleObject.module_settings.operator = value
    },
    assignDatoFelt(value) {
      this.moduleObject.module_settings.fields = [{ value }]
      this.moduleObject.module_settings.customVariableValue = value
    },
    assignCollectionType(value) {
      this.moduleObject.module_settings.fields = [{ value }]
      this.moduleObject.module_settings.clientCollectionType = value
    },
    assignClientType(value) {
      this.moduleObject.module_settings.fields = [{ value }]
      this.moduleObject.module_settings.clientTypeValue = value
    },
  },
}
</script>

<style lang="scss">
</style>
